import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

interface ConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const ConfirmNavigateBackDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onCancel,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{'Sind Sie sicher?'}</DialogTitle>
      <DialogContent>
        {
          <>
            Falls Sie lediglich innerhalb des Dialogs einen Schritt zurückgehen
            möchten, nutzen Sie bitte den Button „Zurück“ am unteren Seitenrand.
            Ihre bereits eingegebenen Daten bleiben dann erhalten.
            <br />
            Sie benötigen eine Pause? Sie können Ihre Eingaben jederzeit
            speichern und zu einem anderen Zeitpunkt fortsetzen.
          </>
        }
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color='error' variant='contained'>
          {'Abbrechen'}
        </Button>
        <Button onClick={onConfirm} color='primary' autoFocus>
          {'Zurück zur Dialogauswahl'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
